import { QueryClient } from '@tanstack/react-query';
import { getCreateService } from '@phishtool/service';
import { fetch } from '@phishtool/ui';
export const queryClient = new QueryClient();
export const createService = getCreateService(fetch, queryClient);
